import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { IssuesService } from 'src/app/_services/issues.service';

@Component({
  selector: 'app-note-dialog',
  templateUrl: './note-dialog.component.html',
  styleUrls: ['./note-dialog.component.scss'],
})
export class NoteDialogComponent implements OnInit {
  dialogData: any;

  constructor(
    public config: DynamicDialogConfig,
    private issueService: IssuesService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.dialogData = this.config.data.formdata;
  }

  updateRemarks(issue: any): void {
    // The textarea is bound via [(ngModel)]="issue.remarks", so the edited
    // text lives on `issue.remarks` itself - not a reactive form control.
    this.issueService.updateActiveIssue(issue.id, { remarks: issue.remarks }).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Remarks updated',
          key: 'active_issues',
        });
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update remarks',
          key: 'active_issues',
        });
      },
    });
  }
}
